import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { LoggedInCallback } from './service/cognito.service';
import { PosthogService } from './service/posthog.service';
import { UserLoginService } from './service/user-login.service';

@Component({
  selector: 'app-root',
  templateUrl: 'template/app.html',
  standalone: false,
})
export class AppComponent implements OnInit, LoggedInCallback {
  public userService = inject(UserLoginService);
  private posthogService = inject(PosthogService);
  public router = inject(Router);

  ngOnInit() {
    this.userService.getAndSetMe();
    this.userService.isAuthenticated(this);
    combineLatest([this.userService.auth.user$, this.userService.currentProfileLoaded$]).subscribe(([claims, profile]) => {
      if (!claims) return;
      this.posthogService.identify(
        claims.sub,
        claims.email,
        Object.keys(profile?.roles?.branch ?? {}),
        profile?.roles?.system,
        profile?.location_roles,
      );
    });
  }

  isLoggedIn() {}
}
